import { Injectable } from "@angular/core";
import { AngularFireAuth } from "@angular/fire/auth";
import { Router } from "@angular/router";

import { Observable, of } from "rxjs";
import { filter, first, switchMap } from "rxjs/operators";
import { auth } from "firebase";
import * as firebase from "firebase";

import { HttpClient } from "@angular/common/http";
import { catchError, map, tap } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  public user$: Observable<firebase.User>; 
  // private user: any;
  public userData$: any;

  constructor(
    private afAuth: AngularFireAuth,
    private router: Router,
    private http: HttpClient
  ) {
    this.user$ = this.afAuth.authState.pipe(
      switchMap((user) => {
        if (user) {
          // this.user = user;
          localStorage.setItem("user", JSON.stringify(user));
          return of(user);
        } else {
          localStorage.removeItem("user");
          return of(null);
        }
      })
    );
  }

  getToken(): string {
    let user = JSON.parse(localStorage.getItem("user"));
    return user.stsTokenManager.accessToken;
  }

  async signOut() {
    localStorage.removeItem("user");
    localStorage.removeItem("trueUser");
    localStorage.clear();
    await this.afAuth.signOut();
    this.router.navigate(["welcome"]);
  }
}
